import React from 'react';

interface Icon3DGlobeProps {
  size?: string;
}

const Icon3DGlobe: React.FC<Icon3DGlobeProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1000px' }}>
      <div 
        className="w-full h-full rounded-full bg-gradient-to-br from-blue-400 to-blue-600 shadow-lg"
        style={{
          animation: 'spin 20s linear infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <div className="w-full h-full rounded-full absolute inset-0 bg-gradient-to-b from-blue-300/50 to-transparent opacity-60" />
        <div 
          className="absolute w-1 h-1 bg-blue-200 rounded-full"
          style={{ 
            top: '30%', 
            left: '20%',
            boxShadow: '8px 4px 0 rgba(191, 219, 254, 0.6), -8px 2px 0 rgba(191, 219, 254, 0.5), 6px -6px 0 rgba(191, 219, 254, 0.4)'
          }}
        />
      </div>
      <style>{`
        @keyframes spin {
          from { transform: rotateY(0deg) rotateX(10deg); }
          to { transform: rotateY(360deg) rotateX(10deg); }
        }
      `}</style>
    </div>
  );
};

export default Icon3DGlobe;
